// native.js — Brücke zur ViaCamp-App (Flutter-WebView, mobile/lib/screens/webview_screen.dart): Teilen, Pull-to-refresh, Sensoren.
// shareData(): Ergebnis 'shared' | 'cancelled' | 'unsupported' — bei 'unsupported' zeigt der Aufrufer seine
// Ausweichlösung (Link kopieren). Die Android-WebView kennt navigator.share nicht; die App bietet dafür 'share'.
// Ältere App-Versionen kennen 'pullToRefresh' nicht — der Aufruf bleibt dann wirkungslos.
export function bridge(win = typeof window !== 'undefined' ? window : null) {
  const b = win && win.flutter_inappwebview;
  return b && typeof b.callHandler === 'function' ? b : null;
}

export const canShare = (win = typeof window !== 'undefined' ? window : null) => !!(bridge(win) || (win && win.navigator && win.navigator.share));

export async function shareData(data, win = typeof window !== 'undefined' ? window : null) {
  const b = bridge(win);
  if (b) {
    try { const r = await b.callHandler('share', data); if (r && r.ok) return 'shared'; } catch { /* Brücke kaputt → Web-Weg */ }
  }
  if (win && win.navigator && win.navigator.share) {
    try { await win.navigator.share(data); return 'shared'; } catch (e) { if (e && e.name === 'AbortError') return 'cancelled'; }
  }
  return 'unsupported';
}

/** Pull-to-refresh der App ab-/anschalten (Vollbild-Karte). Im Browser ohne Wirkung. */
export function nativePullToRefresh(enabled, win = typeof window !== 'undefined' ? window : null) {
  const b = bridge(win);
  if (!b) return false;
  try { Promise.resolve(b.callHandler('pullToRefresh', { enabled: !!enabled })).catch(() => {}); } catch { return false; }
  return true;
}

// ---------- Sensoren und Bildschirm (Plan Werkzeuge/Sensoren; Vertrag in mobile/SYNC.md) ----------
// Ältere Apps kennen diese Handler nicht: flutter_inappwebview antwortet dann mit null. Jeder Aufruf liefert deshalb
// „nicht verfügbar“ (false bzw. null) statt zu werfen — auch ohne App und bei einer kaputten Brücke.
async function callSafe(name, args, win) {
  const b = bridge(win);
  if (!b) return null;
  try { return (await b.callHandler(name, args)) ?? null; } catch { return null; }
}
const okOf = (r) => !!(r && r.ok);

/** Magnetometer der App an/aus. Werte kommen als `vc-sensor`-Ereignis mit `detail.kind === 'magnet'` (µT). */
export async function nativeMagnetometer(on, { periodMs } = {}, win = typeof window !== 'undefined' ? window : null) {
  const args = { on: !!on };
  if (on && Number.isFinite(periodMs) && periodMs > 0) args.periodMs = Math.round(periodMs);
  return okOf(await callSafe('magnetometer', args, win));
}

/** Kompass der App an/aus (nur unter iOS genutzt). Werte als `vc-sensor` mit `detail.kind === 'heading'`. */
export async function nativeHeading(on, win = typeof window !== 'undefined' ? window : null) {
  return okOf(await callSafe('heading', { on: !!on }, win));
}

/** Bildschirm wach halten über die App (wakelock_plus). */
export async function nativeWakeLock(on, win = typeof window !== 'undefined' ? window : null) {
  return okOf(await callSafe('wakeLock', { on: !!on }, win));
}

/** Echte Pixeldichte des Displays (Android: xdpi/ydpi). null, wenn die App sie nicht liefert. */
export async function nativeDisplay(win = typeof window !== 'undefined' ? window : null) {
  const r = await callSafe('display', {}, win);
  const n = (v) => typeof v === 'number' && Number.isFinite(v) && v > 0;
  return r && n(r.xdpi) && n(r.ydpi) && n(r.dpr) ? { xdpi: r.xdpi, ydpi: r.ydpi, dpr: r.dpr } : null;
}
